import { AppBar } from '@mui/material'
import styled from 'styled-components'
import { COLORS } from 'utils'

const HeaderMenu = styled(AppBar)`
  background: ${COLORS.lightGray};
  max-height: 66px;
  padding: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 8px solid ${COLORS.tableColor};
`
const Container = styled.div`
  width: 100%;
  max-height: 66px;
  margin-top: 4rem;
  background: ${COLORS.headerColor};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`
const ContentContainer = styled.div`
  padding: 16px 32px;
  display: flex;
  flex-direction: column;
`
const LogoContainer = styled.div`
  max-width: 115px;
`
const ImageContainer = styled.div`
  max-width: 750px;
  height: 66px;
`
export {
  Container,
  HeaderMenu,
  ImageContainer,
  LogoContainer,
  ContentContainer
}
